/**
 * Theme Toggle Component
 * Floating button to switch between Vegas and Christmas themes
 */

import { useRaffleTheme } from '@/hooks/use-raffle-theme';
import { Sparkles, TreePine } from 'lucide-react';

export function ThemeToggle() {
  const { theme, toggleTheme } = useRaffleTheme();

  return (
    <button
      onClick={toggleTheme}
      className="fixed top-4 right-4 z-50
        min-h-[44px] min-w-[44px] p-3
        rounded-full
        bg-white/10 backdrop-blur-sm
        border border-white/20
        hover:bg-white/20 hover:scale-110
        active:scale-95
        transition-all duration-200
        cursor-pointer
        group
        raffle-glow-effect"
      aria-label={`Switch to ${theme === 'vegas' ? 'Christmas' : 'Vegas'} theme`}
      title={`Switch to ${theme === 'vegas' ? 'Christmas' : 'Vegas'} theme`}
    >
      <div className="raffle-theme-toggle-icon">
        {theme === 'vegas' ? (
          <TreePine className="w-6 h-6 text-green-400 group-hover:text-green-300" />
        ) : (
          <Sparkles className="w-6 h-6 text-yellow-400 group-hover:text-yellow-300" />
        )}
      </div>
    </button>
  );
}

/**
 * Snowflakes component for Christmas theme decoration
 */
export function Snowflakes() {
  const { theme } = useRaffleTheme();

  if (theme !== 'christmas') {
    return null;
  }

  const snowflakes = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    animationDelay: `${Math.random() * 5}s`,
    animationDuration: `${5 + Math.random() * 10}s`,
    fontSize: `${0.5 + Math.random() * 1}rem`,
  }));

  return (
    <div className="raffle-snowflakes">
      {snowflakes.map((flake) => (
        <span
          key={flake.id}
          className="raffle-snowflake"
          style={{
            left: flake.left,
            animationDelay: flake.animationDelay,
            animationDuration: flake.animationDuration,
            fontSize: flake.fontSize,
          }}
        >
          *
        </span>
      ))}
    </div>
  );
}
